import React, { Component } from "react";
import {
  Grid,
  Typography,
} from "@material-ui/core";
import { connect } from "react-redux";
import { getSavedPosts } from "../../redux/user";
import { textBlack, textGrey, webFont } from "../../config/theme";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import SinglePost from "../../components/Posts/SinglePost";

const defaultImg = "/images/simple-chef.webp";

class PList extends Component {
  state = {
    postsList: [],
    loading: false,
    isLoaded: false
  };

  componentDidMount() {
    this.props.dispatch(getSavedPosts(this.props.userId));
  }

  handleClick = post => {
    const { history, userId, isChef } = this.props;
    if (isChef && userId === post.chefId) {
      history.push("/home/add-post", { post });
    } else {
      history.push("/home/post-details", { postId: post.id, screen: 'saved' });
    }
  };

  render() {
    const { savedPosts, loading } = this.props;

    const generatePosts = savedPosts.map((post, index) => {
      return (
        <Grid className="featured-post-item">
          <SinglePost
            post={post}
            index={index}
            page={"home"}
            saved={true}
            handleClick={this.handleClick}
          />
        </Grid>
      );
    });
    return (
      <Grid container direction="row" style={style.ftGrid}>
        {loading && (
          <Grid item md={12} style={{ textAlign: "center" }}>
            <CircularProgress color="primary" />
          </Grid>
        )}

        <Grid container alignItems="flex-start">
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }} />
          <Grid item xs={6} md={4} lg={4} xl={2} >
            <Typography variant="h5" style={{...style.ftText, textAlign: 'center' }} align={"center"}>
              Saved posts
            </Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }}  />
        </Grid>

        <Grid container className="saved-post-container" alignItems={"center"} justify={"center"}>
          {generatePosts}
        </Grid>

        {savedPosts.length < 1 && <Grid container alignItems={"center"} justify={"center"} style={{ marginTop: 20 }}>
          <Typography className="mb-40" variant="h5" style={style.ftText}>
            No saved posts
          </Typography>
        </Grid>}

      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    savedPosts: state.user.savedPosts,
    isChef: state.auth.isChef
  };
};

const PostsList = connect(mapStateToProps)(PList);

export default PostsList;
const style = {
  avatarImg: {
    width: 292,
    height: 292,
    borderRadius: 0
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    marginBottom: 40,
    fontSize: 30,
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    paddingLeft: 25
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
    paddingLeft: 25
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30,
    fontFamily: webFont
  },
  card: {
    //display: "flex"
  },
  details: {
    display: "flex",
    flexDirection: "column"
  },
  content: {
    flex: "1 0 auto"
  },
  cover: {
    width: 151
  },
  setFont: {
    fontFamily: webFont
  },
  littleHeavy: {
    fontWeight: 500,
  },
  moveRight: {
    marginLeft: 10,
    paddingTop: 5,
    paddingBottom: 5
  }
};
